export default __webpack_public_path__ + "static/media/Serie2000.819dd227.jpg";